import { render, staticRenderFns } from "./FiltrosCampanha.vue?vue&type=template&id=6354b278&scoped=true&"
import script from "./FiltrosCampanha.vue?vue&type=script&lang=js&"
export * from "./FiltrosCampanha.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosCampanha.vue?vue&type=style&index=0&id=6354b278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6354b278",
  null
  
)

export default component.exports